import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import AdminDashboard from '../../components/organization/AdminDashboard'

export default function AdminRequestPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <AdminDashboard />
        </>
    )
}
